export default __webpack_public_path__ + "static/media/select_file.22080fbc.png";